import { useState } from 'react';
import { SupplierSidebar } from '@/components/sidebars';
import { OnboardingWidget } from '@/components/supplier/OnboardingWidget';

export function SupplierLayout() {
  const [isCollapsed, setIsCollapsed] = useState(false);

  return (
    <>
      <SupplierSidebar isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
      <OnboardingWidget />
    </>
  );
}
